import React from 'react';
import PropTypes from 'prop-types';
import './snackbarWrapper.scss';

const SnackbarWrapper = ({ message, className, onCloseSnackbar }) => (
    <div className={className}>
        <div className="notification notification-info">
            <svg>
                <use xlinkHref="#svg-icon-info" />
            </svg>
            <div className="notification-content">
                <p>{message}</p>
            </div>
            <button onClick={onCloseSnackbar} type="button" className="btn-icon-ghost">
                <i className="icon-amplify-close" />
            </button>
        </div>
    </div>
);

SnackbarWrapper.defaultProps = {
    message: null,
    className: '',
    onCloseSnackbar: () => {},
};

SnackbarWrapper.propTypes = {
    message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    className: PropTypes.string,
    onCloseSnackbar: PropTypes.func,
};

export default SnackbarWrapper;
